import { memo } from 'react'
import { RaContainer } from '@components/core/index.core'

import type { AcfSearchProps } from '@typings'

export const AcfSearch = memo(({ placeholder, title }: AcfSearchProps) => {
  return (
    <RaContainer>
      <h2>{title}</h2>
      <h4>{placeholder}</h4>
    </RaContainer>
  )
})
